import { round, truncate } from 'lodash'
import { Text } from '@mantine/core'
import Note from '../../../../../components/Note'
import { reviewNotes } from '../../../../../utils/review'
import type { ColumnType } from '../../../../../components/AdminDataTable'
import type { VehicleRow } from './types'

export const columns: ColumnType<VehicleRow>[] = [
  {
    accessor: 'modele',
    title: 'Modèle',
    render: (vehicle) => (
      <div>
        <Text size="sm" fw={500}>{vehicle.name ?? vehicle.modele}</Text>
        <Text size="xs" c="dimmed" mt={2}>
          {truncate(vehicle.sra_commercial ?? vehicle.brand?.title, { length: 24 })}
        </Text>
      </div>
    ),
  },
  {
    accessor: 'reviews_count',
    title: "Nombre d'avis",
    textAlign: 'center',
    width: 120,
    render: (vehicle) => (
      <Text size="sm">{vehicle.reviews_count?.toLocaleString() ?? '—'}</Text>
    ),
  },
  {
    accessor: 'note',
    title: 'Note moyenne',
    textAlign: 'center',
    width: 120,
    sortable: true,
    render: (vehicle) => <Note note={round(vehicle.note, 1)} size="small" />,
  },
  ...(reviewNotes.map((note) => ({
    accessor: note.name,
    title: truncate(note.label, { length: 15 }),
    textAlign: 'center' as const,
    width: 120,
    sortable: true,
    render: (vehicle: VehicleRow) => {
      const value = round(vehicle.notes?.[note.name] ?? 0, 1)
      return <Note note={value} size="small" />
    },
  }))),
]
